module.exports = __webpack_public_path__ + "static/media/1_Create.18b8b6b5.png";